<ion-content>
  <ion-row class="mb-10">
    <ion-col size="12" size-lg="auto" class="borderbottomForTab pb-0">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="dwm-header-menu height-100">
        <a *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Manager' || loggedInUserRole === 'Employee' || loggedInUserRole === 'HOD' || userIsAdminTypes?.userIsAdmin"
          mat-tab-link [routerLink]="['dwm-reports']" routerLinkActive #rla9="routerLinkActive" [active]="rla9.isActive"
          class="dwm-header-menu-nav height-100">
          <span class="material-icons mr-10">description</span>
          DWM Report
        </a>
        <a *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' " mat-tab-link
          [routerLink]="['dump-reports']" routerLinkActive #rla8="routerLinkActive" [active]="rla8.isActive"
          class="dwm-header-menu-nav height-100">
          <span class="material-icons mr-10">analytics</span>
          Dump Report
        </a>


      </nav>
    </ion-col>


  </ion-row>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</ion-content>